module.exports = __webpack_public_path__ + "static/sh-2b4e624092071102ed78fc9bbefbadda.jpg";